<div
  class="wrapper"
  [ngClass]="{
    medium: size === waitingIndicatorSize.Medium,
    small: size === waitingIndicatorSize.Small,
    tiny: size === waitingIndicatorSize.Tiny
  }"
>
  <div class="item first"></div>
  <div class="item second"></div>
  <div class="item third"></div>
</div>
